import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { CalendarRange, ArrowRight } from "lucide-react";

const PL = { DREAM: "#D4AF37", PRODUCT_PROOF: "#3B82F6", VALUE: "#10B981", AFFORDABILITY: "#E69500", COMMUNITY: "#A78BFA", TRUST: "#38BDF8", FAQ: "#F472B6" };

export default function WeeklyPlan() {
  const [wk, setWk] = useState(null);
  const [offset, setOffset] = useState(0);
  const nav = useNavigate();
  useEffect(() => { api.weekly(offset).then(setWk); }, [offset]);
  if (!wk) return <div className="text-[#94A3B8] font-mono2 text-sm">Loading plan…</div>;

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="flex items-center gap-2 eyebrow text-[#D4AF37]"><CalendarRange className="w-4 h-4" /> {wk.title}</div>
          <h1 className="font-display text-3xl sm:text-4xl mt-1">This week in Thailand marketing</h1>
        </div>
        <div className="flex gap-2">
          <button onClick={() => setOffset(offset - 1)} className="px-3 py-2 rounded-lg border border-[#2A3042] text-sm text-[#94A3B8]">‹ Prev</button>
          <button onClick={() => setOffset(0)} className="px-3 py-2 rounded-lg border border-[#2A3042] text-sm text-[#94A3B8]">This week</button>
          <button onClick={() => setOffset(offset + 1)} className="px-3 py-2 rounded-lg border border-[#2A3042] text-sm text-[#94A3B8]">Next ›</button>
        </div>
      </div>

      <div className="grid sm:grid-cols-3 gap-4">
        <Info label="Objective" value={wk.objective} />
        <Info label="Recommended frequency" value={wk.recommended_frequency} />
        <Info label="CTA emphasis" value={wk.cta_emphasis} />
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {wk.plan.map((d) => (
          <div key={d.day} className="card-lux p-5" data-testid={`plan-${d.day}`}>
            <div className="flex items-center justify-between mb-2">
              <span className="font-mono2 text-xs text-[#94A3B8] uppercase tracking-wider">{d.day}</span>
              <span className="text-[10px] px-2 py-0.5 rounded-full" style={{ background: (PL[d.pillar] || "#666") + "22", color: PL[d.pillar] || "#999" }}>{d.pillar_label}</span>
            </div>
            <div className="font-display text-lg text-[#F8FAFC] leading-tight">{d.focus}</div>
            <div className="text-xs text-[#64748B] mt-2">{d.channel} · {d.theme}</div>
            <button onClick={() => nav("/create", { state: { spec: { content_type: d.format, pillar: d.pillar, theme: d.theme, platform: d.channel } } })}
              className="mt-3 text-xs text-[#F3E5AB] hover:underline inline-flex items-center gap-1">Create this <ArrowRight className="w-3 h-3" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
const Info = ({ label, value }) => (
  <div className="card-lux p-5"><div className="eyebrow text-[#D4AF37] mb-1">{label}</div><div className="text-[#F8FAFC]">{value}</div></div>
);
